<template>
    <span class="text-dense" :style="style" :class="cssClass"> {{ localizedEnum }} </span>
</template>

<script>
import {formatAsLocalizedEnum} from "@/common/format";

export default {
	data() {
		return {
			localizedEnum: "",
            style: "",
			cssClass: ""
        }
    },
    beforeMount() {
		let enumDef = this.params.colDef.enumDef;
		let value = this.params.value;

		this.localizedEnum = formatAsLocalizedEnum(enumDef, value);

		if (enumDef.hasOwnProperty("properties") && enumDef.properties.hasOwnProperty(value)) {
            this.style = enumDef.properties[value].style;
            this.cssClass = enumDef.properties[value].cssClass
        }
    }
};
</script>

<style lang="scss">
</style>
